/**
 * Bridge between MSAL (React context) and the API client (non-React).
 * A component with useMsal() calls setMsalTokenGetter(() => acquireTokenSilent(...)).
 * The API client calls getTokenFromMsal() to get the Bearer token.
 */

let tokenGetter: (() => Promise<string | null>) | null = null;

export function setMsalTokenGetter(getter: () => Promise<string | null>): void {
  tokenGetter = getter;
}

export function clearMsalTokenGetter(): void {
  tokenGetter = null;
}

export async function getTokenFromMsal(): Promise<string | null> {
  if (!tokenGetter) return null;
  try {
    return await tokenGetter();
  } catch {
    return null;
  }
}
